var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelegate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.3359 12.334C5.43959 12.334 6.3359 13.2303 6.3359 14.334C6.3359 15.438 5.43959 16.334 4.3359 16.334C3.23224 16.334 2.33594 15.438 2.33594 14.334C2.33594 13.2303 3.23224 12.334 4.3359 12.334Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6719 1C18.7755 1 19.6718 1.89635 19.6718 3C19.6718 4.10402 18.7755 5 17.6719 5C16.5682 5 15.6719 4.10402 15.6719 3C15.6719 1.89635 16.5682 1 17.6719 1Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66668 19.6667V21H1V19.6667C1 17.827 2.49365 16.3334 4.33332 16.3334C6.17299 16.3334 7.66668 17.827 7.66668 19.6667Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0026 8.33367V9.66699H14.3359V8.33367C14.3359 6.494 15.8296 5.00035 17.6693 5.00035C19.509 5.00035 21.0026 6.494 21.0026 8.33367Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66406 1.00031L10.9974 2.33363L9.66406 3.66699",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3334 21L11 19.6667L12.3334 18.3333",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.33594 9.66699C2.33594 5.61965 5.62191 2.33367 9.66922 2.33367",
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6692 12.3337C19.6692 16.381 16.3832 19.667 12.3359 19.667",
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelegate);
export default __webpack_public_path__ + "static/media/Delegate.63ef7fb5799af2096626440aa22d4dde.svg";
export { ForwardRef as ReactComponent };